import { DataService } from "./DataService.js";
import { ChunkDataService, chunkDataServiceConf } from "./export.js";


export class AppDataService extends DataService {
    constructor(req, conf, gudhub) {
        super();
        this.chunkDataService = new ChunkDataService(req, chunkDataServiceConf, gudhub);
        this.gudhub = gudhub;
    }


    isWithCache() {
        return false;
    }

    async processRequestedApp(id, sentData) {
        if (
            !this.isWithCache()
        ) {

            let res = await this.chunkDataService.getMergedChunkForIDList(id, sentData.chunks);

            if (
                res
            ) {
                sentData.items_list = await this.gudhub.util.mergeChunks([
                    res,
                    sentData,
                ]);
            }

            return sentData;
        }

        return sentData;

        // following code will work for cases with enabled cache
    }
}